import React from 'react';
import { Card, Typography, Divider } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

const Rules = () => {
  return (
    <Card
      title={<><FileTextOutlined /> HT Run Rules</>}
      style={{ maxWidth: 900, margin: '0 auto' }}
    >
      <Typography>
        <Paragraph>
          感谢各位报名参与我们的黑龙团！
        </Paragraph>
        <Paragraph>
          作为一个maple木叶工会新成立的黑龙团，我们还在不断学习，不断进步。既感谢大佬们的出力，也欢迎新手朋友们踊跃参与黑龙的远征活动~目前根据现在已经运行的几场HT Run，我们制定了一些基础团队规则，保障每位队员公平利益同时，让打本流程更加顺畅！感谢各位配合遵守~
        </Paragraph>

        <Title level={3}>HT Run远征队规章制度</Title>

        <Title level={4}>等级要求</Title>
        <ul>
          <li>等级155+</li>
          <li style={{ listStyle: 'none', marginLeft: -20, color: '#888' }}>
            (由于黑龙对160级以下的角色具有伤害减免的效果，建议至少160)
          </li>
        </ul>

        <Divider />

        <Title level={4}>远征队开打前</Title>
        <ul>
          <li>集合地点 CC4 Peak of the Big Nest</li>
          <li>请全员务必于开战前10分钟于通知的地点集合并组建队伍，若遇到突发情况无法参加，务必于黑龙开打前至少6小时告知Host，方便及时补人替补，严禁耽误全队所有人的时间。( 这点很重要。对于迟到、缺席惩罚请看下文 )</li>
          <li>开打前一定要检查是否有宠物回血装备过期的情况，以及是否有自身活动装备过期导致装备穿不上的情况。</li>
          <li>开打前提前备齐 变身药剂、回复药水、雪碧等增益药水、宠物饲料、ACP 等全部消耗物资，不临时拖延进度。</li>
          <li>可自行邀请好友参与。</li>
          <li>务必提前关闭宠物拾取功能。</li>
        </ul>

        <Divider />

        <Title level={4}>远征队战斗中</Title>
        <ul>
          <li>禁止战斗过程中的一切赌博roll点行为。</li>
          <li>禁止战斗过程中一切双开leech或同时打其他boss的行为。</li>
          <li>全程听从Host统一指挥安排。</li>
          <li>恶意故意捣乱、故意拖节奏，打字废话聊天直接做举报处理。</li>
          <li>遇到突发特殊状况，Host有权决定继续完成远征或全员撤退。</li>
          <li>为保证效率，中途休息如需延长时间，请提前告知Host（紧急突发情况除外），常规休息时间统一为十分钟。</li>
          <li>休息超时且未提前报备者，Host有权扣除该队员分红，扣除部分平分给团内其他所有人。</li>
        </ul>

        <Divider />

        <Title level={4}>分红分配规则</Title>
        <ul>
          <li>所有收益统一由银行账户( ign：AllJ8Brobank )入账保管，想要提取分红，我在分配完成之后，登录报名网站，检查自己的银行账户余额，申请提取并联系我 ( QQ：348195591 )</li>
          <li>掉落物品，分红明细，都会清晰登记在报名网站中。</li>
          <li>严重迟到、休息超时以及恶意捣乱(尤其是赌博roll点，双开leech)等违规行为，Host有权扣除对应分红，扣款平分给其余队员。</li>
          <li>特殊掉落物品分配方式（项链，龙椅，Boss卡），由Host开战前于dis 骰子roll频道提前roll点并公布。</li>
          <li>道具售卖价格参考市场行情与猫头鹰成交价，最终定价归Host所有。</li>
          <li>队员可95折内购本次攻坚掉落的所有道具。</li>
          <li>特殊价值道具：如GEN30、MW20等技能书，内购价为在市场价最低的基础上-5C/10m，仅限自用购买，禁止倒卖套利。</li>
        </ul>

        <Divider />

        <Paragraph style={{ color: '#666', marginTop: 24 }}>
          <Text strong>最后补充一些：</Text>
          <br />
          其实黑龙副本并没有大家想象中那么有收益，刷下来收益并不稳定，有时候会出现全程空气不出货的情况，收益起伏很大。但抛开装备掉落不谈，副本本身给到的经验收益十分可观，组队攻坚的过程也极具趣味性。大家可以借着打本的机会多结识队内伙伴，拓展游戏人脉，在冒险路上认识更多志同道合的朋友~
        </Paragraph>
      </Typography>
    </Card>
  );
};

export default Rules;
